module.exports = __webpack_public_path__ + "static/media/tick_1.f476e3d6.svg";